import React from 'react';
import ReactDOM from 'react-dom';
import history from '../history';
import cancelEvent from '../services/mini/cancelEvent';

function withClickOutside(WrappedComponent, overlayClass, closeBlockingClasses = [], customCloseOnEsc, customOutsideCb) {
    return class extends React.Component {
        constructor(props, context) {
            super(props, context);
            this.handleClickOutsideCb = this.handleClickOutsideCb.bind(this);
            this.onKeyCb = this.onKeyCb.bind(this);
        }

        componentDidMount() {
            document.addEventListener('mousedown', this.handleClickOutsideCb, true);
            document.addEventListener('keyup', this.onKeyCb, false);
            if (!window.alanConfirmAlertListener) {
                window.alanConfirmAlertListener = true;
                history.listen(async () => {
                    this._close({ target: {} });
                });
            }
        }

        componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutsideCb, true);
            document.removeEventListener('keyup', this.onKeyCb, false);
        }

        onKeyCb(e) {
            let keyCode = e.keyCode;

            if (keyCode === 27) {
                if (customCloseOnEsc) {
                    customCloseOnEsc();
                } else {
                    this._close(e);
                }
            }
        }

        handleClickOutsideCb(e) {
            var domNode = ReactDOM.findDOMNode(this);

            if (e.target.classList.contains('toast') ||
                e.target.closest('.toast') !== null) {
                return;
            }

            if (e.target.classList.contains('combo-box') ||
                e.target.closest('.combo-box') !== null) {
                return;
            }

            if (customOutsideCb) {
                customOutsideCb();
                return;
            }

            if ((!domNode || !domNode.contains(e.target))) {
                this._close(e);
                cancelEvent(e);
            }

            if (overlayClass) {
                if (e.target.classList.contains(overlayClass)) {
                    this._close(e);
                    cancelEvent(e);
                }
            }
        }

        _close(e) {
            for (let i = 0; i < closeBlockingClasses.length; i++) {
                if (document.getElementsByClassName(closeBlockingClasses).length > 0) {
                    cancelEvent(e);
                    return;
                }
            }

            if (typeof this.props.onClose === 'function') {
                this.props.onClose(e);
            } else if (typeof this.props.onOutsideClick === 'function') {
                this.props.onOutsideClick(e);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

export default withClickOutside;